module.exports = __webpack_public_path__ + "static/media/saudi-arabia.239857ca.svg";